import { useEffect } from 'react';
import { useAriaLive } from '@ally/use-aria-live';
export var useLoading = function (ariaLiveLoading, loading) {
    var announceAssertive = useAriaLive().announceAssertive;
    var isLoading = typeof loading === 'boolean' ? loading : typeof loading === 'number';
    useEffect(function () {
        if (isLoading) {
            announceAssertive(ariaLiveLoading);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);
    return {
        isLoading: isLoading,
        loadingPercentage: typeof loading === 'number' && loading >= 0 && loading <= 100
            ? loading
            : undefined,
    };
};
//# sourceMappingURL=useLoading.js.map